import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { AuthenticationService } from './core/services/authentication.service';
import { VersionCheckService } from './core/services/version-check.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Atom';
  spinnerType = SPINNER.circle;

  constructor(
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private authService: AuthenticationService,
    private versionCheckService: VersionCheckService
  ) {
    // Checking if SSO login request or not
    if (window.location.href.includes('code=')) {
      const hUrl = window.location.href.replace('&', '');
      const urlSplit = hUrl.split('=');

      this.router.navigate(['/sso'], { queryParams: { code: urlSplit[3], session_state: urlSplit[2], clientCode: urlSplit[1].split('#')[0] } });
    }
  }

  ngOnInit() {
    this.ngxService.start();
    setTimeout(() => {
      this.ngxService.stop();
    }, 500);
    if (this.authService.checkUserlogin()) {
      this.authService.startSessionMonitoring();
    }
    this.versionCheckService.startVersionCheck();
  }


}
